import { videos } from '../../videos';
import { VideoListingHeroContent } from '@/types';

export const hero: VideoListingHeroContent = {
  headline: {
    before: 'Video Productions',
    subtitle: `Lights, camera, action!
    Watch our specially curated videos and see how it’s done at Digital Colliers. `
  },
  video: {
    ...videos.whoWeAre,
    description: {
      before: 'Digital Colliers in Office',
      subtitle: 'Kraków, Poland'
    }
  }
};
